/**
 * Created by pli on 8/25/2016.
 */
angular.module('common.directive.monetaryUnit', ['common.helper', 'taric.model.monetaryunits']).component('agMonetaryUnit',{
    bindings: {
        monetaryUnitId: '@',
        monetaryUnitCodeId: '@',
        monetaryUnitDescription: '@',
        monetaryUnitCodeDescription: '@',
        monetaryUnit: '<',
        control: '=',
        fromDate: '<',
        onMonetaryUnitChange: '&',
        onHandleError: '&'
    },
    controller: function (MonetaryUnitsModel, CommonHelper, $filter, $translate, $rootScope) {
        var ctrl = this;

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.getMonetaryUnits = function(){
            if (!ctrl.monetaryUnitsResult){
                return [];
            }
            var monetaryUnits = ctrl.monetaryUnitsResult.items;
            return monetaryUnits.sort(function (monetaryUnit1, monetaryUnit2) {
                return (monetaryUnit1.id).localeCompare((monetaryUnit2.id), CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.loadMonetaryUnits = function(){
            ctrl.monetaryUnits = ctrl.getMonetaryUnits();
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            ctrl.loadMonetaryUnits();
        });

        ctrl.reload = function(reloadDate){
            if (!reloadDate){
                return;
            }
            ctrl.monetaryUnitCode = null;
            MonetaryUnitsModel.customsValueMonetaryUnits(reloadDate).then(function (monetaryUnits) {
                ctrl.monetaryUnitsResult = monetaryUnits;
                ctrl.monetaryUnitCode = ctrl.monetaryUnit;
                ctrl.loadMonetaryUnits();
            }, function (error) {
                ctrl.handleError(error.data.code, error.data.params);
            });
        };

        //Update the monetaryUnit select box when user enters the monetaryUnit in the input text
        ctrl.monetaryUnitCodeChange = function () {
            var monetaryUnitCode = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnitCode);

            //Wait until user enters 3 characters
            if(monetaryUnitCode.length === 2){
                return;
            } else {
                //Find the monetaryUnit from the list
                var found = false;
                for (let i = 0; i < ctrl.monetaryUnitsResult.items.length; i++) {
                    var monetaryUnitId = ctrl.monetaryUnitsResult.items[i].id;
                    if (ctrl.monetaryUnitCode.toUpperCase() === monetaryUnitId) {
                        ctrl.monetaryUnit = monetaryUnitId;
                        found = true;
                        break;
                    }
                }
                if (!found){
                    ctrl.monetaryUnit = null;
                }
                ctrl.onMonetaryUnitChange({monetaryUnit: ctrl.monetaryUnit});
            }
        };

        //Update the monetaryUnit when the monetaryUnits select box is changed
        ctrl.monetaryUnitChange = function () {
            ctrl.monetaryUnitCode = ctrl.monetaryUnit;
            ctrl.onMonetaryUnitChange({monetaryUnit: ctrl.monetaryUnit});
        };

        ctrl.validate = function(){
            var monetaryUnitCode = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnitCode);
            var monetaryUnit = CommonHelper.removeSpaceCharacters(ctrl.monetaryUnit);

            if (monetaryUnitCode.toUpperCase() !== monetaryUnit.toUpperCase()){
                return "i18n.common.validation.monetary.code.invalid";
            }
            return null;
        };

        ctrl.updateMonetaryUnitCode = function(monetaryUnitCode){
            ctrl.monetaryUnitCode = monetaryUnitCode;
        };

        ctrl.init = function () {
            if (ctrl.control){
                ctrl.control.reload = ctrl.reload;
                ctrl.control.validate = ctrl.validate;
                ctrl.control.updateMonetaryUnitCode = ctrl.updateMonetaryUnitCode;
            }
            if(!ctrl.monetaryUnitId){
                ctrl.monetaryUnitId = "monetaryUnit";
            }
            if(!ctrl.monetaryUnitCodeId){
                ctrl.monetaryUnitCodeId = "monetaryUnitCode";
            }
            ctrl.reload(ctrl.fromDate);
        };

        ctrl.init();
    },
    templateUrl: 'common/directive/monetary-unit.tmpl.html'
});




// WEBPACK FOOTER //
// ./app/common/directive/monetary-unit.directive.js